import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/HomeButton.css";

export default function HomeButton({ disabled = false }) {
  const navigate = useNavigate();

  return (
    <button
      className="home-button"
      onClick={() => navigate("/")}
      disabled={disabled}
      aria-label="Home"
    >
     🏠︎
    </button>
  );
}

